import { Component, OnInit, ChangeDetectionStrategy, Inject, EventEmitter, AfterViewInit } from '@angular/core';
import { DecodedToken, LastLoggedInUser } from '@core/models';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { AuthenticateUserCommand } from '@core/services/api.service';

@Component({
  selector: 'app-layout-login-dialog',
  templateUrl: './layout-login-dialog.component.html',
  styleUrls: ['./layout-login-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('rotatedState', [
      state('default', style({ transform: 'rotate(0)' })),
      state('rotated', style({ transform: 'rotate(-360deg)' })),
      transition('rotated => default', animate('1500ms ease-out')),
      transition('default => rotated', animate('400ms ease-in'))
    ])
  ]
})
export class LayoutLoginDialogComponent implements OnInit, AfterViewInit {
  loginClicked = new EventEmitter<AuthenticateUserCommand>();
  logoutClicked = new EventEmitter();
  clearLastUserClicked = new EventEmitter();
  forgotPasswordClicked = new EventEmitter();
  selectThemeClicked = new EventEmitter<string>();

  lastLoggedInUser$: Observable<LastLoggedInUser>;
  isLoading$: Observable<boolean>;
  hasValidToken$: Observable<boolean>;
  decodedToken$: Observable<DecodedToken>;
  theme$: Observable<string>;
  state = 'default';
  changePassword: false;

  constructor(
    public dialogRef: MatDialogRef<LayoutLoginDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      decodedToken$: Observable<DecodedToken>,
      hasValidToken$: Observable<boolean>,
      lastLoggedInUser$: Observable<LastLoggedInUser>,
      isLoading$: Observable<boolean>,
      theme$: Observable<string>
    }
  ) { }

  ngOnInit() {
    this.lastLoggedInUser$ = this.data.lastLoggedInUser$;
    this.hasValidToken$ = this.data.hasValidToken$;
    this.decodedToken$ = this.data.decodedToken$;
    this.isLoading$ = this.data.isLoading$;
    this.theme$ = this.data.theme$;
  }

  ngAfterViewInit() {
    this.rotate();
  }

  selectTheme(theme: string) {
    this.selectThemeClicked.emit(theme);
  }

  close() {
    this.dialogRef.close();
  }

  logout() {
    this.logoutClicked.emit();
    this.dialogRef.close();
  }

  login($authenticateUserCommand: AuthenticateUserCommand) {
    this.loginClicked.emit($authenticateUserCommand);
  }

  clearLastUser() {
    this.clearLastUserClicked.emit();
  }

  rotate() {
    this.state = (this.state === 'default' ? 'rotated' : 'default');
  }

  forgotPassword() {
    this.forgotPasswordClicked.emit();
    this.dialogRef.close();
  }
}
